/**
 * Generated by orval. Do not edit manually.
 */

export type InsiderStakesChoice = (typeof InsiderStakesChoice)[keyof typeof InsiderStakesChoice]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InsiderStakesChoice = {
  low: 'low',
  mid: 'mid',
  high: 'high',
  nosebleeds: 'nosebleeds',
} as const
